@if (open() && !isDeleting()) {
  <app-modal
    [config]="confirmModalConfig()"
    [title]="'features.plan.delete.title' | translate"
    (closeModal)="close()">
    <div modal-body class="my-4 flex flex-col gap-3 text-sm">
      @if (blocked().length > 0) {
        <p class="text-text-primary">
          {{
            'features.plan.delete.blocked_deployed'
              | translate: { count: blocked().length, plans: planLabels(blocked()) }
          }}
        </p>
      } @else {
        <p class="text-text-primary">
          {{ 'features.plan.delete.confirm' | translate: { count: targets().length } }}
        </p>

        @if (addedChildren().length > 0) {
          <p class="text-text-secondary">
            {{
              'features.plan.delete.children_notice'
                | translate
                  : {
                      count: addedChildren().length,
                      plans: planLabels(addedChildren())
                    }
            }}
          </p>
        }
      }
    </div>
  </app-modal>
}

@if (isDeleting()) {
  <app-modal
    [config]="progressModalConfig"
    [title]="'features.plan.delete.title' | translate">
    <div modal-body class="flex flex-col items-center gap-4 px-4 py-8 text-center">
      <div
        class="border-accent-main h-10 w-10 animate-spin rounded-full border-2 border-b-transparent"></div>
      <p class="text-text-secondary max-w-xs text-sm">
        {{ 'features.plan.delete.in_progress' | translate: { count: targets().length } }}
      </p>
    </div>
  </app-modal>
}
